import React from "react";
import BootstrapTable from "@partseye/react-bootstrap-table-next";
import "@partseye/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "@partseye/react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css";
import { formatCurrencyAmount } from '../culture';

export default class PartNumberChangeHistory extends React.Component {
    
    render() {
        const tableColumns = [
            {
                "dataField": "partNumber",
                "text": this.props.pageText.partNumber,
                "formatter": (val, row) => (row.active ? <a href="#" onClick={() => { this.props.updateInfoSkuPK(row.inventorySKUPK, row.makeSkuPK) }}>
                                {val}
                            </a> : <span>{val}</span>)
            },
            {"dataField": "sequence",
                "text": this.props.pageText.sequence},
            {"dataField": "onOrder",
                "text": this.props.pageText.onOrder},
            {"dataField": "onHand",
                "text": this.props.pageText.onHand},
            {"dataField": "onHandValue",
                "text": this.props.pageText.onHandValue,
                "formatter": (val) => formatCurrencyAmount(val, this.props.sessionInfo.selected, true, true)},
            {"dataField": "forwardOnly",
                "text": this.props.pageText.forwardOnly}
        ];
        this.props.OptUseAvailableToGenerateOrder && console.log("condition true");
        this.props.OptUseAvailableToGenerateOrder && tableColumns.splice(3, 0, {
            "dataField": "onHandAvailable",
            "text": this.props.pageText.qtyAvail || "Qty Avail"
        },)

        return (
            <div className="basic-info part-history container-fluid">
                <h5 className="basic-info-title title">
                    {this.props.pageText.changeHistoryTitle}
                    <i
                        className="material-icons"
                        title={this.props.pageText.changeHistoryToolTip}
                    >
                        help
                    </i>
                </h5>
                <div className={this.props.partInfo.length > 5 ? "basic-info-content-with-scrolled fixed-height" : "basic-info-content"}>
                    <BootstrapTable
                        bootstrap4
                        columns={tableColumns}
                        condensed
                        data={this.props.partInfo}
                        headerClasses="thead-light"
                        id="partChangeHistory"
                        keyField="sequence"
                    />
                </div>
            </div>
        );

    }

}
